import * as React from "react";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import "../resume/Resume.css";
import {
  Card,
  CardMedia,
  Tab,
  Tabs,
  CardActionArea,
  Grid,
  CardContent,
  Typography,
  Grow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { useState } from "react";
import resumeData from "../../utils/resumeData";
import "./Portfolio.css";
import ImageGallery from "../../components/imageGallery/ImageGallery";
import CustomButton from "../../components/main/button/Button";

const Portfolio = () => {
  const [tabValue, setTabValue] = useState("All");
  type ProjectType = (typeof resumeData.projects)[number];
  const [projectDialog, setProjectDialog] = useState<ProjectType | false>(
    false
  );

  // Handle browser history for modal
  React.useEffect(() => {
    // Handler for popstate event
    const handlePopState = (event: PopStateEvent) => {
      if (projectDialog) {
        setProjectDialog(false);
      }
    };
    if (projectDialog) {
      window.history.pushState({ modal: true }, "");
      window.addEventListener("popstate", handlePopState);
    }
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
    // Only run when projectDialog changes
  }, [projectDialog]);

  // Helper to close modal and go back in history if needed
  const handleCloseDialog = React.useCallback(() => {
    if (projectDialog) {
      setProjectDialog(false);
      // Only go back if the last state was pushed by us
      if (window.history.state && window.history.state.modal) {
        window.history.back();
      }
    }
  }, [projectDialog]);

  const getTagInitial = (tag: string) => {
    switch (tag) {
      case "Websites":
        return "W";
      case "Apps":
        return "A";
      case "PCs":
        return "P";
      default:
        return "";
    }
  };

  return (
    <>
      {/* Portfolio */}
      <Grid container className="section pb-45 pt-45">
        {/* title */}
        <Grid item className="section-title bottom-20">
          <span></span>
          <h6 className="section-title-text">Portfolio</h6>
        </Grid>

        {/* Tabs */}
        <Grid item xs={12}>
          <Tabs
            value={tabValue}
            indicatorColor="primary"
            className="customTabs bottom-30"
            textColor="primary"
            onChange={(tabEvent, newValue) => setTabValue(newValue)}
          >
            <Tab
              label="All"
              value="All"
              className={
                tabValue === "All"
                  ? "customTabs-item active"
                  : "customTabs-item"
              }
            />
            {Array.from(
              new Set(resumeData.projects.map((item) => item.tag))
            ).map((tag) => (
              <Tab
                label={tag}
                value={tag}
                className={
                  tabValue === tag
                    ? "customTabs-item active"
                    : "customTabs-item"
                }
              />
            ))}
          </Tabs>
        </Grid>

        {/* projects */}
        <Grid item xs={12}>
          <Grid container spacing={3}>
            {resumeData.projects.map((project) => (
              <>
                {tabValue === project.tag || tabValue === "All" ? (
                  <Grid item xs={12} sm={6} md={4}>
                    <Grow in timeout={1000}>
                      <div className="cardWrapper">
                        <Card
                          className="customCard"
                          onClick={() => setProjectDialog(project)}
                        >
                          <div className="tagCornerCircleWrapper">
                            <div
                              className={`tagCornerCircle tag-${getTagInitial(
                                project.tag
                              )}`}
                            >
                              {getTagInitial(project.tag)}
                            </div>
                          </div>
                          <CardActionArea>
                            <CardMedia
                              className="customCard-image"
                              image={project.image}
                              title={project.title}
                            />
                            <CardContent>
                              <Typography
                                variant="body1"
                                className="customCard-title"
                              >
                                {project.title}
                              </Typography>
                              <Typography
                                variant="caption"
                                className="customCard-caption"
                              >
                                {project.caption}
                              </Typography>
                            </CardContent>
                          </CardActionArea>
                        </Card>
                      </div>
                    </Grow>
                  </Grid>
                ) : null}
              </>
            ))}
          </Grid>
        </Grid>
        <Dialog
          open={!!projectDialog}
          onClose={handleCloseDialog}
          maxWidth={"lg"}
          fullWidth
          className="projectDialog"
        >
          <DialogTitle className="projectDialog-title">
            <Typography variant="h6">
              {projectDialog && projectDialog.title}
            </Typography>
            <Typography>
              {/* eslint-disable-next-line */}
              <IconButton
                aria-label="close"
                onClick={handleCloseDialog}
                className="projectDialog-closeButton"
                size="medium"
              >
                <CloseIcon style={{ fontSize: 36 }} />
              </IconButton>
            </Typography>
          </DialogTitle>
          <DialogContent>
            {projectDialog && projectDialog.tag === "Apps"
              ? projectDialog?.app
              : projectDialog &&
                projectDialog.images && (
                  <ImageGallery images={projectDialog.images} />
                )}
            <Typography
              variant="body2"
              className="projectDialog-description"
              component="div"
              dangerouslySetInnerHTML={{
                __html: projectDialog && projectDialog.description,
              }}
            />
          </DialogContent>
          <DialogActions className="projectDialog-actions">
            {projectDialog &&
              projectDialog.links &&
              projectDialog.links.map((link) => (
                <CustomButton
                  text={link.text}
                  icon={link.icon}
                  href={link.link}
                />
              ))}
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
};

export default Portfolio;
